import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { ConsumerOfferManagerHandler } from '../../providers/consumer-offer-handler';
import { ConsumerOfferDetailPage } from '../consumer-offer-detail/consumer-offer-detail';


@Component({
  selector: 'page-consumer-offer-multi-status',
  templateUrl: 'consumer-offer-multi-status.html',
})
export class ConsumerOfferMultiStatusPage {
	loadingMsg: any = "Loading...";
	isLoading: boolean = false;
	offerToRedeemCount: any = 0;
	offerRedeemCount: any = 0;

	constructor(
		public loadingCtrl: LoadingController,
		public offerHandler: ConsumerOfferManagerHandler,
		public navCtrl: NavController, 
		public navParams: NavParams) {
	}

	ionViewWillEnter(){
		this.loadInvoiceDetail();
	}		

	loadInvoiceDetail(){
		this.isLoading = true;

		if(this.offerHandler.selectedOffer.InvoiceId!=null){
			this.offerHandler.invoiceId = this.offerHandler.selectedOffer.InvoiceId;
		}

		this.offerHandler.getOfferMulti(
			{
				id: this.offerHandler.invoiceId, 
				cb: (data: any)=>{
					this.offerToRedeemCount = this.offerHandler.offerToRedeemCount();
					this.offerRedeemCount = this.offerHandler.offerRedeemCount();
					
					this.isLoading = false;
				}
			}
		);
	}	

	redeem(){
		var loader = this.loadingCtrl.create({
			content: "Working...",
			showBackdrop: true
		});

		loader.present();			

		var offer: any = this.offerHandler.pickOfferToRedeem();
	
		this.offerHandler.getOfferByInvoiceDetail({
			id: offer.Id,
			cb: (returnedOffer)=>{
				loader.dismiss();

				this.offerHandler.selectedOffer = returnedOffer;

				this.navCtrl.push(ConsumerOfferDetailPage);	
			}
		})
	}
}



// WEBPACK FOOTER //
// ./src/pages/consumer-offer-multi-status/consumer-offer-multi-status.ts